export default "__VITE_ASSET__CQlrVNxB__"